<template>
    <div class="collapsible-option" :class="optionCssClasses">
        <div class="header" :class="headerCssClasses" @click="select">
            <div class="icon" @click.stop="toggle"></div>
            <div class="title">
                <slot :item="value.item"
                      :title="value.title"
                      :disabled="value.disabled"
                >{{ value.title }}
                </slot>
            </div>
        </div>
        <div class="nested">
            <Node v-for="it in value.nested"
                  v-show="it.visible"
                  :key="it.key" :value="it"
                  :level="level + 1"
                  :selected="selected"
                  :flat-groups="flatGroups"
                  :selectable-groups="selectableGroups"
                  @selected="$emit('selected', $event)">
                <template #default="{item, title, disabled}">
                    <slot :item="item"
                          :title="title"
                          :disabled="disabled"
                    >{{ title }}
                    </slot>
                </template>
            </Node>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Node',
    props: {
        value: {
            type: Object,
            required: true
        },
        selected: {

        },
        selectableGroups: {
            type: Boolean,
            default: false
        },
        flatGroups: {
            type: Boolean,
            default: false
        },
        level: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            collapsed: true
        };
    },
    computed: {
        optionCssClasses() {
            return {
                flat     : this.flatGroups,
                hasnested: this.hasNested,
                collapsed: this.collapsed,
                ['level-' + this.level]: true
            };
        },
        headerCssClasses() {
            return {
                active  : this.checked,
                disabled: this.value.disabled,
            };
        },
        hasNested() {
            return this.value.nested.length > 0;
        },
        checked() {
            return this.selected === this.value.key;
        },
        selectable() {
            return !this.hasNested || this.selectableGroups;
        },
    },
    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
        },
        select() {
            if (this.selectable) {
                this.$emit('selected', this.value);
            } else {
                this.toggle();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import './node.scss';
</style>
